import axios from '../../../../utills/axiosConfig';

export const fetchMoulds = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/moulds', { params });
  return res.data;
};

export const addMould = async (mould) => {
  try {
    const res = await axios.post('/moulds', mould);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateMould = async (id, mould) => {
  const res = await axios.put(`/moulds/${id}`, mould);
  return res.data;
};

export const deleteMould = async (id) => {
  const res = await axios.delete(`/moulds/${id}`);
  return res.data;
};

export const importMouldCSV = async (formData) => {
  const { data } = await axios.post('/moulds/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 